import React from 'react';
import cx from 'classnames';
import { string, shape, func, bool } from 'prop-types';

import WithSubtitle from 'components/WithSubtitle';
import InlineButton from 'components/InlineButton';
import SegmentXL from 'icons/segment-large.inline.svg';
import CloseIcon from 'icons/close.inline.svg';

import styles from './LocationsHeader.scss';

export default function LocationsHeader({
  fromLocation,
  toLocation,
  className,
  removeLocation,
  isFinished,
}) {
  const noLocation = !toLocation;

  return (
    <div className={cx(styles.main, className)}>
      <SegmentXL className={styles.icon} />
      <div className={styles.groupedItems}>
        {fromLocation &&
          <div className={styles.item}>
            <WithSubtitle
              title="from"
              className={styles.label}
              contentClassName={styles.labelContent}
            >
              {fromLocation.name}
            </WithSubtitle>
            {!isFinished &&
              <InlineButton hasContextCreationPanel onClick={() => removeLocation(fromLocation.id)}>
                <CloseIcon />
              </InlineButton>}
          </div>}

        {fromLocation &&
          <div className={cx(styles.item, { [styles.noLocation]: noLocation })}>
            <WithSubtitle
              title="to"
              className={styles.label}
              contentClassName={styles.labelContent}
            >
              {!toLocation && <span className={styles.hint}>&hellip;</span>}
              {toLocation && toLocation.name}
            </WithSubtitle>
            {!isFinished &&
              toLocation &&
              <InlineButton hasContextCreationPanel onClick={() => removeLocation(toLocation.id)}>
                <CloseIcon />
              </InlineButton>}
          </div>}
      </div>
    </div>
  );
}

LocationsHeader.propTypes = {
  fromLocation: shape({ name: string, id: string }),
  toLocation: shape({ name: string, id: string }),
  removeLocation: func.isRequired,
  className: string,
  isFinished: bool.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/MapPanel/CreateSegment/LocationsHeader/index.js